import { Clear } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { memo } from 'react';

export const ResetButton = memo(
  ({
    value,
    onReset,
    disabled,
  }: {
    value: string;
    onReset: () => void;
    disabled: boolean;
  }) => {
    if (!value) return null;

    return (
      <Tooltip title="Reset field">
        <span style={{ display: 'inline-flex' }}>
          <IconButton size="small" onClick={onReset} disabled={disabled} aria-label="Reset field">
            <Clear fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    );
  }
);

ResetButton.displayName = 'ResetButton';
